import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-16 pb-10 px-4 sm:px-6 lg:px-8" data-id="element-52">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-53" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10 mt-[-50px] mb-[-50px]" data-id="element-54">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="inline-block mb-4 px-3 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold-light text-sm font-medium tracking-wider uppercase pt-[4px] pb-[4px]" data-id="element-55">
          The Dream Decoding System™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: [0.97, 1.03, 1]
      }} transition={{
        duration: 1.2,
        ease: 'easeOut',
        scale: {
          duration: 2.5,
          ease: [0.25, 0.1, 0.25, 1],
          times: [0, 0.6, 1]
        }
      }} className="text-[58px] sm:text-[72px] lg:text-[84px] font-bold tracking-tight mt-[0px] mb-[0px] leading-[0.85]" data-id="element-56">
          Decode Any
          <br data-id="element-57" />
          Dream in
          <br data-id="element-58" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-59">
            Minutes
          </span>
        </motion.h1>

        {/* Product mockup — above subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 1,
        type: 'spring',
        stiffness: 50
      }} className="relative w-full max-w-sm sm:max-w-md mb-0" data-id="element-60">
          <div className="relative rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/5" data-id="element-61">
            <img src="https://cdn.magicpatterns.com/uploads/8cKvpNraq6AFMtXGTtsMWQ/Diseno_sin_titulo_(27).png" alt="The Dream Decoding System Product" className="w-full h-auto object-cover rounded-3xl mt-[21px] mb-[21px]" data-id="element-62" />
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="text-xl sm:text-2xl max-w-2xl font-light leading-relaxed text-white/90 mt-[-6px] mb-[-6px]" data-id="element-63">
          A proven{' '}
          <span className="font-[700] text-[#FFD64D]" data-id="element-64">step-by-step system</span>
          <br data-id="element-65" />
          to{' '}
          <span className="text-white font-[600]" data-id="element-66">
            understand your dreams
          </span>{' '}
          and
          <br data-id="element-67" />
          get <span className="text-white font-[600]" data-id="element-68">clear answers</span> fast.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="flex flex-col items-center space-y-0 mt-[0px] mb-[0px]" data-id="element-69">
          <Button href="#checkout" className="w-full sm:w-auto min-w-[280px]" data-id="element-70">
            Get Instant Access
          </Button>
          <p className="text-sm text-zinc-500 flex items-center gap-2 mt-2 mb-0" data-id="element-71">
            <span data-id="element-72">One-time payment</span>
            <span className="w-1 h-1 rounded-full bg-zinc-600" data-id="element-73"></span>

            <span data-id="element-74">Mobile-friendly</span>
          </p>
        </motion.div>
      </div>
    </section>;
}